import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import FrontierSliders from "components/FrontierSliders/FrontierSliders";

import * as projectReducer from "containers/Project/reducer";
import * as setupReducer from "containers/Setup/reducer";

export const FRONTIER_SLIDERS_VIEW = {
  FRONTIER: "Frontier",
  SELECTED: "Selected",
  FEEDBACK: "Feedback",
  CAPACITY: "Capacity",
  HIDE: "Hide"
};

class FrontierSlidersContainer extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    return <FrontierSliders {...this.props} />;
  }
}

// JOHN:
// You will need to disable/reset adjustments when people click `No Adjustments`
// in the AdvancedDeploy component in `components/Project/AdvancedDeploy`
const mapDispatchToProps = (dispatch, ownProps) => {
  const { id, hideHeader, overrideSliderView } = ownProps;

  return {
    updateShowShortListed: (val) => dispatch(projectReducer.updateShowShortListed(id, val)),
    updateShowPending: (val) => dispatch(projectReducer.updateShowPending(id, val)),
    updateSliderView: (val) => dispatch(projectReducer.updateSliderView(id, val)),

    updateFrontierPercentProcessedMin: (runId, frontierPercentProcessedMin) =>
      dispatch(setupReducer.updateFrontierPercentProcessedMin(runId, frontierPercentProcessedMin)),
    updateFrontierPercentProcessedMax: (runId, frontierPercentProcessedMax) =>
      dispatch(setupReducer.updateFrontierPercentProcessedMax(runId, frontierPercentProcessedMax)),

    getFrontierPercentProcessedMin: (runId, defaultVal) =>
      dispatch((dispatch, getState) => setupReducer.getFrontierPercentProcessedMin(getState(), runId, defaultVal)),

    getFrontierPercentProcessedMax: (runId, defaultVal) =>
      dispatch((dispatch, getState) => setupReducer.getFrontierPercentProcessedMax(getState(), runId, defaultVal))
  };
};

const mapStateToProps = (state, ownProps) => {
  const { id, hideHeader, overrideSliderView } = ownProps;

  return {
    modelGroups: projectReducer.getModelGroups(state, id, undefined, false),

    project: projectReducer.getProject(state, id),

    showShortListed: projectReducer.getShowShortListed(state, id),

    showPending: projectReducer.getShowPending(state, id),

    sliderView: projectReducer.getSliderView(state, id),

    selectedScenario: projectReducer.getSelectedScenario(state, id)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(FrontierSlidersContainer);
